import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";

const FacilityManagement = () => {
  return (
    <div>
      <PageTitle title='Facility Management' role='Facility Manager' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='Facility Managers have the ability to edit facilities in his or her own organization. This can be done by accessing the Facility Management page. To get to the Facility Management page, click on the "Administration" tab at the top. After the drop down appears, click on the "Facilities" option.' />
      <ParaImageDialog src='/tutorial_image/facility-management-1.png' />
      
      <ParaTitle paraTitle='Create a New Facility' />
      <Paragraph paragraph='To create a New Facility, click on the "Create" icon in the top header bar.' />
      <ParaImageDialog src='/tutorial_image/facility-management-2.png' />
      <Paragraph paragraph='A modal will appear and prompt the Facility Manager to fill in the information regarding the new facility. Once filled out, the Facility Manager will click on "Create". Immediately after clicking "Create", a notification will appear in the top right corner saying the new facility has been created.' />

      <ParaTitle paraTitle='Edit a Facility' />
      <Paragraph paragraph='To edit facility information, click the "Edit" button in the table. A modal will appear prompting the user to make any changes to the facility&#39;s profile. After making the correct modifications, click the "Update" button at the bottom of the modal to save the changes.' />
      <ParaImageDialog src='/tutorial_image/facility-management-3.png' />

      <ParaTitle paraTitle='Delete a Facility' />
      <Paragraph paragraph='To delete an existing facility, click the arrow next to the "Edit" button to view additional actions. Listed in the drop down is a "Delete" option. Select this option and confirm the action to delete the facility. Note: Facility managers cannot delete their current facility. In order to delete their own facility, the manager must change their facility first.' />
      <ParaImageDialog src='/tutorial_image/facility-management-4.png' />
      
      <Pagination
        pagination={{
          prev: { name: 'Change Facility', link: '/organization-manager/change-facility' },
          next: { name: 'Dashboard Reports', link: '/reports/dashboard-reports' }
        }}
      />
      {/* &#39; */}
    </div>
  );
};

export default FacilityManagement;
